import React, { useRef } from "react";
import "antd/dist/antd.css";
import i18next from "i18next";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import { Editor } from "@tinymce/tinymce-react";
import "./HTMLEditor.css";
import AppConfig from "../../config/AppConfig";
import Constants from "../../config/Constants";
import ApiService from "../../services/ApiService";
import * as Helper from "../../utils/Helper";
import juice from  "juice/client";
import trackChangeCssContent from '../../../public/tinymce/plugins/trackchanges/trackchange.css?raw';
import rangyRaw from '../../../public/tinymce/plugins/trackchanges/rangy-core.js?raw';
import Mp3Recorder from 'recorder-core';
import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';
import 'recorder-core/src/extensions/waveview';
import 'recorder-core/src/extensions/frequency.histogram.view';
import 'recorder-core/src/extensions/lib.fft';
import MessageBox from "./MessageBox";
import MD5 from "../../mobile/utils/MD5";
import EventEmitter from "../../mobile/utils/EventEmitter";
import SpeechRecognition from "../../mobile/components/customModule/speechRecognition/SpeechRecognition";
import { recognizeServiceTypeEnum } from "../../mobile/components/customModule/speechRecognition/SpeechCommonHelper";

//import "@npkg/tinymce-plugins";
//https://blog.csdn.net/qq_41923622/article/details/111810804
//https://github.com/Five-great/tinymce-plugins/issues

import UIDs from "../../UIDs";
const uid = UIDs.components.ui.htmleditor;

window.Mp3Recorder = Mp3Recorder;
window.showAlert = (msg) => {
    MessageBox.danger({ text: msg, duration: 5000 });
};

function normalizeFileName(fullname) {
    let name = fullname;
    let pos = fullname.lastIndexOf('.');
    let suffix = '';
    if (pos >= 0) {
        suffix = fullname.substring(pos);
        name = fullname.substring(0, pos);
    }
    name = MD5.hex_md5(name);
    return name + suffix;
}

function getPopupMaxWidth() {
    let winWidth = window.innerWidth - 50;
    if (winWidth < 600) {
        return winWidth;
    }
    return 600;
}

function getPopupMaxHeight() {
    return window.innerHeight - 100;
}

function showASRText(rect, text) {
    var mask = document.createElement("div");
    mask.style.display = 'block';
    mask.style.position = 'absolute';
    mask.style.zIndex = 99999;
    mask.style.left = "0px";
    mask.style.top = "0px";
    mask.style.right = "0px";
    mask.style.bottom = "0px";
    function closePopup() {
        document.body.removeChild(mask);
    }
    mask.onclick = closePopup;

    var div = document.createElement("div");
    div.innerText = text;
    div.className = 'audiojs_asr_popover';
    div.style.display = 'block';
    div.style.position = 'absolute';
    div.style.maxWidth = getPopupMaxWidth() + 'px';
    div.onclick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    document.body.appendChild(div);
    const rc = div.getBoundingClientRect();
    const width = rc.width;
    const height = rc.height;

    var x = rect.right;
    var y = (rect.top - height);
    if (y < 0) {
        y = 0;
    }

    if (y + height > window.innerHeight) {
        y = window.innerHeight - height;
    }

    if (x + width > window.innerWidth) {
        x = window.innerWidth - width;
    }

    div.style.left = x + "px";
    div.style.top = y + "px";
    div.style.zIndex = 99999;

    document.body.removeChild(div);
    mask.appendChild(div);
    document.body.appendChild(mask);
}

function getMp3FileFromUrl(url, fileName) {
    return new Promise((resolve, reject) => {
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        //xhr.setRequestHeader('Accept', 'audio/mp3');
        xhr.responseType = "blob";
        xhr.onload = () => {
            blob = xhr.response;
            let mp3File = new File([blob], fileName, { type: 'audio/mp3' });
            resolve(mp3File);
        };
        xhr.onerror = (e) => {
            reject(e)
        };
        xhr.send();
    });
}

function fileToArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.readAsArrayBuffer(file);
        fr.addEventListener("loadend", (e) => {
            resolve(e.target.result);
        }, false);
    });
}

function float32ToInt16(floatArray) {
    let int16Array = new Int16Array(floatArray.length);
    for (let i = 0; i < floatArray.length; i++) {
        let intVal = floatArray[i] * 32767; // 将浮点数缩放到Int16的范围
        int16Array[i] = intVal < 0 ? intVal | 0 : intVal | ~0; // 使用位运算符处理溢出
    }
    return int16Array;
}

async function splitMp3Files(file, secs) {
    const buffer = await fileToArrayBuffer(file);
    const audioContext = new AudioContext({sampleRate: 16000});

    //Convert ArrayBuffer into AudioBuffer
    const decodedData = await audioContext.decodeAudioData(buffer);
    const totalSecs = decodedData.duration;
    if (totalSecs <= secs) {
        audioContext.close();
        return [file];
    }

    const result = [];
    let startPos = 0;
    while (startPos < totalSecs) {
        let endPos = startPos + secs;
        if (endPos > totalSecs) {
            endPos = totalSecs;
        }

        let computedStart = decodedData.length * startPos / decodedData.duration;
        let computedEnd = decodedData.length * endPos / decodedData.duration;
        if (computedEnd > decodedData.length) {
            computedEnd = decodedData.length;
        }

        const newBuffer = audioContext.createBuffer(decodedData.numberOfChannels, computedEnd - computedStart , decodedData.sampleRate)

        // Copy from old buffer to new with the right slice.
        // At this point, the audio has been cut
        for (var i = 0; i < decodedData.numberOfChannels; i++) {
            newBuffer.copyToChannel(decodedData.getChannelData(i).slice(computedStart, computedEnd), i);
        }

        const channels = decodedData.numberOfChannels;
        const sampleRate = newBuffer.sampleRate;
        const bitRate = 16;
        const mp3encoder = new Mp3Recorder.lamejs.Mp3Encoder(channels, sampleRate, bitRate);

        let left = null;
        let right = null;
        if (2 == decodedData.numberOfChannels) {
            left = float32ToInt16(newBuffer.getChannelData(0));
            right = float32ToInt16(newBuffer.getChannelData(1));
        } else {
            left = float32ToInt16(newBuffer.getChannelData(0));
        }

        const sampleBlockSize = 1152; //can be anything but make it a multiple of 576 to make encoders life easier
        const mp3Data = [];
        for (let i = 0; i < left.length; i += sampleBlockSize) {
            let leftChunk = left ? left.subarray(i, i + sampleBlockSize) : null;
            let rightChunk = right ? right.subarray(i, i + sampleBlockSize) : null;
            let mp3buf = null;
            if (leftChunk && rightChunk) {
                mp3buf = mp3encoder.encodeBuffer(leftChunk, rightChunk);
            } else {
                mp3buf = mp3encoder.encodeBuffer((leftChunk || rightChunk));
            }

            if (mp3buf.length > 0) {
                mp3Data.push(mp3buf);
            }
        }

        const mp3buf = mp3encoder.flush();   //finish writing mp3
        if (mp3buf.length > 0) {
            mp3Data.push(new Int8Array(mp3buf));
        }

        const blob = new Blob(mp3Data, {type: 'audio/mp3'});
        const mp3File = new File([blob], '', { type: 'audio/mp3' });
        result.push(mp3File);

        startPos = endPos;
    }

    audioContext.close();
    return result;
}

async function recognizeMp3File(file) {
    // 阿里云识别限制单个录音1分钟, 拆分成多个音频文件识别
    const files = await splitMp3Files(file, 55);
    let result = '';
    for (let i = 0; i < files.length; ++i) {
        const response = await SpeechRecognition.recognizeFile(files[i], true);
        result += response;
    }
    return result;
}

function recognizeAudio(src, cb) {
    var mask = document.createElement("div");
    mask.style.display = 'flex';
    mask.style.alignItems = 'center';
    mask.style.justifyContent = 'center';
    mask.style.position = 'absolute';
    mask.style.zIndex = 99999;
    mask.style.left = "0px";
    mask.style.top = "0px";
    mask.style.right = "0px";
    mask.style.bottom = "0px";
    mask.style.backgroundColor = 'rgba(0,0,0,0.5)';

    var div = document.createElement("div");
    div.innerHTML = "<div style='font-size:18px;color:#fff'>" + i18n.t(`${uid}:recognizing`) + "</div>";
    mask.appendChild(div);

    document.body.appendChild(mask);

    function closeMask() {
        document.body.removeChild(mask);
    }

    function finalize() {
        closeMask();
        SpeechRecognition.stopRecognize();
        SpeechRecognition.removeAllListeners();
        SpeechRecognition.destroy();
    }

    SpeechRecognition.initWithoutKey({
        lang: Constants.SPEECH_LANG.zh,
        enableSpeechRecognize: false,
        noRequirePermission: true,
        // NOTE: 阿里云国际不支持mp3识别, 强制使用国内的阿里云
        useProxy: false,
        serviceType: recognizeServiceTypeEnum.AliYunIAT,
        recognizeServiceType: recognizeServiceTypeEnum.AliYunIAT,
        rejectPermissionCallback: () => {
        },
        initFailCallback: (title, content, buttonText) => {
        },
        backgroundStopRecordCallback: () => {
        },
    }).then(() => {
        getMp3FileFromUrl(src, "record")
            .then((file) => {
                recognizeMp3File(file)
                    .then((response) => {
                        cb(response);
                        finalize();
                    })
                    .catch((e) => {
                        alert(String(e));
                        finalize();
                    });
            })
            .catch((e) => {
                alert(String(e));
                finalize();
            });
    }).catch(e => {
        alert(String(e));
        closeMask();
    });
}

function createButton(item, height) {
    var btn = document.createElement("div");
    btn.className = 'audiojs_menu_button';
    btn.style.height = height + "px";
    btn.onclick = item.onclick;
    btn.innerText = item.text;
    return btn;
}

function downloadFile(url, fileName) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.target = "_blank";
            link.click();
        });
}

window.onAudioToTextClick = (audio, e) => {
    recognizeAudio(audio.mp3, (text) => {
        const rect = e.target.getBoundingClientRect();
        showASRText(rect, text);
    });
};

window.onAudioDownloadClick = (audio, e) => {
    const filename = audio.mp3.split("/").pop();
    downloadFile(audio.mp3, filename);
};

window.onAudioMoreClick = (audio, e) => {
    const rect = e.target.getBoundingClientRect();

    var mask = document.createElement("div");
    mask.style.display = 'block';
    mask.style.position = 'absolute';
    mask.style.zIndex = 99999;
    mask.style.left = "0px";
    mask.style.top = "0px";
    mask.style.right = "0px";
    mask.style.bottom = "0px";
    function closePopup() {
        document.body.removeChild(mask);
    }
    mask.onclick = closePopup;

    var height = 0;
    var items = [/*{
        text: i18n.t(`${uid}:toText`),
        onclick: () => {
            recognizeAudio(audio.mp3, (text) => {
                showASRText(rect, text);
            });
        },
    }, {
        text: i18n.t(`${uid}:download`),
        onclick: () => {
            const filename = audio.mp3.split("/").pop();
            downloadFile(audio.mp3, filename);
        },
    }, */{
        text: i18n.t(`${uid}:speed`) + " 0.5x",
        onclick: () => {
            audio.setPlaybackRate(0.5);
        },
    }, {
         text: i18n.t(`${uid}:speed`) + " 1x",
         onclick: () => {
             audio.setPlaybackRate(1);
         },
    }, {
          text: i18n.t(`${uid}:speed`) + " 1.5x",
          onclick: () => {
              audio.setPlaybackRate(1.5);
          },
    }, {
         text: i18n.t(`${uid}:speed`) + " 2x",
         onclick: () => {
             audio.setPlaybackRate(2);
         },
    }];
    var btns = [];
    for (let i = 0; i < items.length; ++i) {
        btns.push(createButton(items[i], 40));
        height += 40;
    }

    var width = 200;
    var x = rect.left;
    var y = (rect.top - height);
    if (y < 0) {
        y = 0;
    }

    if (y + height > window.innerHeight) {
        y = window.innerHeight - height;
    }

    if (x + width > window.innerWidth) {
        x = window.innerWidth - width;
    }

    var div = document.createElement("div");
    //div.innerHTML = item.textContent;
    div.className = 'audiojs_menu_popover';
    div.style.display = 'block';
    div.style.position = 'absolute';
    div.style.left = x + "px";
    div.style.top = y + "px";
    div.style.zIndex = 99999;
    div.style.height = height + "px";

    for (let i = 0; i < btns.length; ++i) {
        div.appendChild(btns[i]);
    }

    mask.appendChild(div);
    document.body.appendChild(mask);
};

function getTinymce(view) {
    var global = view;
    return global && global.tinymce ? global.tinymce : null;
}

function updateTinymce() {
    if (getTinymce(window)) {
    } else {
    }
}

// NOTE: 导出的时候句评让一直显示，要不然复制到word里看不到
const cssContent = `
${trackChangeCssContent}

.aic-comment-sentence-node .aic-comment-sentence-icon {
    cursor: auto;
}

.aic-comment-sentence-node .aic-comment-sentence-popover {
    display: inline-block;
    padding:2px 8px;
    background-color:#efbb65;
    color:#333;
    border-radius:6px;
    white-space:normal;
    width: auto!important;
    height: auto!important;
    line-height: 1!important;
    text-indent: 0px;
}

.aic-comment-sentence-node:hover .aic-comment-sentence-popover {
    /* display: inline-block; */
    text-indent: 0px;
}
`;

const file_server_place_holder = '${YIDU_FILE_SERVER}';
const g_url_maps = new Map();

const image_upload_handler = (blobInfo, progress) => new Promise((resolve, reject) => {
    var finished = false;
    var timerId = setInterval(() => {
        if (finished) {
            clearInterval(timerId);
            return;
        }

        var spinner = document.getElementsByClassName("tox-spinner")[0];
        if (spinner) {
            clearInterval(timerId);

            var button = document.createElement("button");
            button.className = 'tox-button tox-button--secondary';
            button.style.marginTop = '20px';
            button.innerText = i18n.t(`${uid}:cancel`);
            button.onclick = () => {
                if (!finished) {
                    finished = true;
                    reject(new Error(i18n.t(`${uid}:operationCancelled`)));
                }
            };

            spinner.parentNode.style.display = 'flex';
            spinner.parentNode.style.flexDirection = 'column';
            spinner.parentNode.style.alignItems = 'center';
            spinner.parentNode.style.justifyContent = 'center';
            spinner.parentNode.appendChild(button);
        }
    }, 100);

    let formData = new FormData();
    formData.append('fileData', blobInfo.blob(), normalizeFileName(blobInfo.filename()));
    formData.append("table", "HTMLEditor");
    formData.append("field", "image");

    ApiService.postFileToServer("/common/file/upload", formData, (response) => {
        if (!finished) {
            finished = true;
            g_url_maps.set(response.absoluteUrl, file_server_place_holder + response.virtualPath);
            resolve(response.absoluteUrl);
        }
    }, (error) => {
        if (!finished) {
            finished = true;
            reject(error);
        }
    });
});

const attachment_upload_handler = (file, succFun, failFun, progressCallback) => {
    //var data = new FormData();
    //data.append("file", file);
    let formData = new FormData();
    const newFileName = normalizeFileName(file.name);
    const newFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified
    });
    formData.append('fileData', newFile);
    formData.append("table", "HTMLEditor");
    formData.append("field", "image");

    let finished = false;
    ApiService.postFileToServer("/common/file/upload", formData, (response) => {
        if (!finished) {
            finished = true;
            g_url_maps.set(response.absoluteUrl, file_server_place_holder + response.virtualPath);
            succFun(response.absoluteUrl);
        }
    }, (error) => {
        if (!finished) {
            finished = true;
            failFun('上传失败:' + error.message)
        }
    });
};

const file_picker_callback = (cb, value, meta) => {
    if (meta.filetype === 'media') {
        //let filetype = '.pdf, .jpg, .jpeg, .png, .gif, .mp3, .mp4';
        let filetype = '.mp3, .mp4';
        let input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', filetype);
        input.onchange = function() {
            let file = this.files[0];
            let formData = new FormData();
            formData.append('fileData', file);
            formData.append("table", "HTMLEditor");
            formData.append("field", "media");

            ApiService.postFileToServer("/common/file/upload", formData, (response) => {
                g_url_maps.set(response.absoluteUrl, file_server_place_holder + response.virtualPath);
                cb(response.absoluteUrl, {
                    title: file.name
                });
            }, (error) => {
                console.warn('upload error:', error);
            });
        }

        input.click();
    }
};

window.image_upload_handler = image_upload_handler;

var g_closeTimer = null;
function closePopoverLater() {
    if (g_closeTimer) {
        return;
    }

    g_closeTimer = setTimeout(() => {
        g_closeTimer = null;
        let popover = getPopoverContainer();
        popover.style.display = 'none';
    }, 200);
}

function setupImageOnclick(node) {
    /* NOTE: 图片旋转工具需要图片能点击, 取消在新页面打开图片
    if (node.onclick) {
        return;
    }

    node.style.cursor = 'pointer';
    node.onclick = () => {
        window.open(node.src);
    };
    */
}

function getPopoverContainer() {
    let popover = document.getElementById("aic-comment-sentence-popover-container");
    if (!popover) {
        popover = document.createElement("div");
        popover.id = 'aic-comment-sentence-popover-container';
        popover.style.display = 'none';
        popover.style.zIndex = 99999;
        document.body.appendChild(popover);

        popover.onmouseover = () => {
            if (g_closeTimer) {
                clearTimeout(g_closeTimer);
                g_closeTimer = null;
            }
        };
        popover.onmouseleave = closePopoverLater;
    }
    return popover;
}

function setupPopover(editor, node) {
    if (node.onmouseover && node.onmouseleave) {
        return;
    }

    node.onmouseover = () => {
        if (g_closeTimer) {
            clearTimeout(g_closeTimer);
            g_closeTimer = null;
        }

        const items = node.querySelectorAll(".aic-comment-sentence-popover");
        const icons = node.querySelectorAll(".aic-comment-sentence-icon");
        if (items && items.length > 0 && icons && icons.length > 0) {
            const item = items[0];
            const icon = icons[0];
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const rect = icon.getBoundingClientRect();
            let xoffset = 0;
            let yoffxet = 0;
            if (editor) {
                let rc = editor.getBoundingClientRect();
                xoffset = rc.left;
                yoffxet = rc.top;
            }

            var div = document.createElement("div");
            div.innerHTML = item.textContent;
            if (isEnableAsr(node)) {
                // 将所有audio换成audiojs, 增加语音识别等功能
                const asrAudios = div.querySelectorAll("audio");
                if (asrAudios.length > 0) {
                    audiojs.createAll(null, asrAudios);
                }
            }

            div.style.display = 'block';
            div.style.position = 'absolute';
            div.style.maxWidth = getPopupMaxWidth() + 'px';
            div.style.wordBreak = 'break-all';
            document.body.appendChild(div);

            let x = xoffset + rect.left;
            let y = yoffxet + rect.top - 8;
            let width = div.clientWidth;
            let height = div.clientHeight;

            document.body.removeChild(div);
            if (width < 1 || height < 1) {
                return;
            }

            // padding
            width += 30;
            height += 30;

            let hasScroll = false;
            if (height > getPopupMaxHeight() - 40) {
                height = getPopupMaxHeight() - 40;
                hasScroll = true;
            }

            y -= height;
            if (y < 0) {
                y = yoffxet + rect.bottom + 8;
            }

            if (y + height > window.innerHeight) {
                x = xoffset + rect.right + 4;
                y = window.innerHeight - height;
            }

            if (x + width > window.innerWidth) {
                x = window.innerWidth - width;
            }

            x += scrollLeft;
            y += scrollTop;

            let popover = getPopoverContainer();
            popover.innerHTML = "";
            popover.style.display = 'block';
            popover.style.position = 'absolute';
            if (hasScroll) {
                popover.style.overflowY = 'auto';
            }
            popover.style.left = parseInt(x) + 'px';
            popover.style.top = parseInt(y) + 'px';
            popover.style.width = parseInt(width) + 'px';
            popover.style.height = parseInt(height) + 'px';
            popover.style.maxWidth = getPopupMaxWidth() + 'px';
            popover.style.maxHeight = getPopupMaxHeight() + 'px';
            popover.style.backgroundColor = '#eeba6c';
            popover.style.border = '1px solid #eeba6c';
            popover.style.borderRadius = '6px';
            popover.style.padding = '10px';
            popover.style.wordBreak = 'break-all';

            div.style.position = 'static';
            popover.appendChild(div);

            const imgs = div.querySelectorAll("img");
            if (imgs && imgs.length > 0) {
                for (let i = 0; i < imgs.length; ++i) {
                    setupImageOnclick(imgs[i]);
                }
            }
        }
    };

    node.onmouseleave = closePopoverLater;
}

function isEnableAsr(audio) {
    let p = audio.parentNode;
    while (p) {
        if (p.enableAsr) {
            return true;
        }
        p = p.parentNode;
    }
    return false;
}

function updateDocumentCommentPopovers(editor, doc) {
    if (editor) {
        const imgs = doc.querySelectorAll("img");
        for (let i = 0; i < imgs.length; ++i) {
            setupImageOnclick(imgs[i]);
        }
    }

    let nodes = doc.getElementsByClassName("aic-comment-sentence-node");
    if (nodes && nodes.length > 0) {
        for (let i = 0; i < nodes.length; ++i) {
            setupPopover(editor, nodes[i]);
        }
    }

    // 将所有audio换成audiojs, 增加语音识别等功能
    const audios = doc.querySelectorAll("audio");
    const asrAudios = [];
    for (let i = 0; i < audios.length; ++i) {
        if (isEnableAsr(audios[i])) {
            asrAudios.push(audios[i]);
        }
    }

    if (asrAudios.length > 0) {
        audiojs.createAll(null, asrAudios);
    }
}

var g_pendingTimer = null;
function updateCommentSentencePopovers() {
    if (g_pendingTimer) {
        clearTimeout(g_pendingTimer);
        g_pendingTimer = null;
    }

    let editors = document.getElementsByClassName("tox-edit-area__iframe");
    if (editors) {
        for (let i = 0; i < editors.length; ++i) {
            let editor = editors[i];
            updateDocumentCommentPopovers(editor, editor.contentWindow.document);
        }
    }

    updateDocumentCommentPopovers(null, document);
}

function updateCommentSentencePopoversLater() {
    if (g_pendingTimer) {
        return;
    }

    g_pendingTimer = setTimeout(() => {
        g_pendingTimer = null;
        updateCommentSentencePopovers();
    }, 200);
}

export class ToolBarAffix extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this._handleScroll);
        this.updateToolBarPos();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._handleScroll);
    }

    _handleScroll = () => {
        this.updateToolBarPos();
    };

    updateToolBarPos() {
        if (Helper.isMobile()) {
            return;
        }

        let top = document.documentElement.scrollTop;
        if (top === undefined) {
            top = document.body.scrollTop;
        }

        const toolbar = this.props.affixClassName ? document.getElementsByClassName(this.props.affixClassName)[0] : this._ref;
        if (toolbar && this._rect) {
            if (this._ref) {
                if (!this._affixed) {
                    let r = this._ref.getBoundingClientRect();
                    let dc = document;
                    let xoffset = dc.documentElement.scrollLeft || dc.body.scrollLeft;
                    let yoffxet = dc.documentElement.scrollTop || dc.body.scrollTop;
                    this._rect = {left: r.left + xoffset,
                                  top: r.top + yoffxet,
                                  right: r.right + xoffset,
                                  bottom: r.bottom + yoffxet};
                }
            }

            if (this.props.placement === "bottom") {
                let bottom = top + window.innerHeight;
                if (bottom < this._rect.bottom) {
                    if (!this._affixed) {
                        this._affixed = true;
                        toolbar.style.position = 'fixed';
                        toolbar.style.bottom = '0px';
                    }

                    if (this.props.minAffixBottom) {
                        let minScroll = this.props.minAffixBottom - window.innerHeight;
                        if (top < minScroll) {
                            toolbar.style.bottom = parseInt(top - minScroll) + 'px';
                        } else {
                            toolbar.style.bottom = '0px';
                        }
                    }
                } else {
                    if (this._affixed) {
                        this._affixed = false;
                        toolbar.style.position = 'static';
                    }
                }
            } else {
                if (top > this._rect.top) {
                    if (!this._affixed) {
                        this._affixed = true;
                        toolbar.style.position = 'fixed';
                        toolbar.style.top = '0px';
                    }
                } else {
                    if (this._affixed) {
                        this._affixed = false;
                        toolbar.style.position = 'static';
                    }
                }
            }
        }
    }

    setupRef = (r) => {
        this._ref = r;
        if (this._ref) {
            this._rect = this._ref.getBoundingClientRect();
            this.updateToolBarPos();
        }
    };

    render() {
        const { ...props } = this.props;
        return (<div ref={this.setupRef} {...props} />);
    }
}

const HTMLEditor = (props) => {
    const htmlEditorRef = useRef();

    const getTinymceLanguage = () => {
        let lan = i18next.language ? i18next.language : "en";
        let lang = "en";
        switch (lan) {
            case "zh":
                lang = "zh_CN";
                break;
            case "ja":
                lang = "ja";
                break;
            case "th":
                lang = "th_TH";
                break;
            case "ko":
                lang = "ko_KR";
                break;
            case "pt":
                lang = "pt_PT";
                break;
            case "fr":
                lang = "fr_FR";
                break;
            case "ru":
                lang = "ru";
                break;
            case "vi":
                lang = "vi";
                break;
            case "mn":
                lang = "mn";
                break;
        }
        return lang;
    };

    if (props.reviewMode) {
        return (<div className="form-group">
                    <ToolBarAffix affixClassName="tox-editor-header">
                    <Editor
                        ref={htmlEditorRef}
                        tinymceScriptSrc={'/tinymce/tinymce.min.js'}
                        //apiKey="60tqj5cv5mqacjd1yo0bfmtvktqx0gb1u51en8xzp91b673p"
                        value={Helper.replaceHtmlVirtualPath(props.htmlContent)}
                        onScriptsLoad={updateTinymce}
                        onEditorChange={(newValue, editor) => {
                            if (!Helper.isMobile()) {
                                updateCommentSentencePopoversLater();
                            }

                            if (props.handleChangeEdit){
                                props.handleChangeEdit(newValue, props.index !== null && props.index !== undefined ? props.index : null);
                            }
                            if (props.handleChangeEditWithEditor){
                                props.handleChangeEditWithEditor(newValue, editor);
                            }
                        }}
                        init={{
                            init_instance_callback: (editor) => {
                                if (!Helper.isMobile()) {
                                    updateCommentSentencePopoversLater();
                                }
                                editor.on('FullscreenStateChanged', onFullScreen.bind(editor));
                            },
                            height: props.height ? props.height : 400,
                            menubar: false,
                            branding: false,
                            convert_urls: false,
                            language: getTinymceLanguage(),
                            placeholder: props.placeholder || '',
                            disable_media: props.peerReview ? true : false,
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'imagetools', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
                                'comment', 'trackchanges', 'placeholder', 'attachment',
                            ],
                            attachment_max_size: 104857600,
                            attachment_style:'.attachment>img{display:inline-block!important;max-width:30px!important;}',
                            attachment_icons_path: '/tinymce/plugins/attachment/icons',
                            attachment_upload_handler: attachment_upload_handler,
                            content_css: ['/tinymce/plugins/trackchanges/trackchange.css'],
                            images_upload_handler: image_upload_handler,
                            // NOTE: file_picker_callback无法显示上传状态
                            //file_picker_types: 'media',
                            //file_picker_callback: file_picker_callback,
                            toolbar_mode: 'sliding',
                            toolbar: [
                                {
                                    name: 'clipboard',
                                    items: ['undo', 'redo']
                                },
                                {
                                    name: 'basicstyles',
                                    items: ['bold', 'italic', 'underline', 'strikethrough'/*, 'subscript', 'superscript', 'removeformat'*/]
                                },
                                {
                                    name: 'aic',
                                    items: ['aic-toggleshow',  'aic-rejectall','aic-rejectone','sentencecomment', 'paragraphcomment']
                                },
                                {
                                    name: 'paragraph',
                                    items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify', 'ltr', 'rtl']
                                },
                                { name: 'colors', items: ['forecolor', 'backcolor'] },
                                {
                                    name: 'basicstyles',
                                    items: ['blocks']
                                },
                                { name: 'styles', items: ['Format', 'fontfamily', 'fontsize'] }, //missing styles
                                {
                                    name: 'clipboard',
                                    items: ['cut', 'copy', 'paste', 'pastetext']
                                },
                                {
                                    name: 'paragraph',
                                    items: ['numlist', 'bullist', 'outdent', 'indent', 'blockquote']
                                },
                                {
                                    name: 'editing',
                                    items: ['searchreplace', 'selectall']
                                },
                                {
                                    name: 'insert',
                                    items: ['table', 'hr', 'emoticons', 'pagebreak', 'image']
                                },
                                { name: 'links', items: ['link', 'unlink'] },
                                { name: 'document', items: ['code', 'preview', 'print'] },
                                { name: 'tools', items: ['fullscreen', 'visualblocks', 'About'] }
                            ],
                            trackChanges: {
                                isTracking: true,
                                isHighlighting: true,
                                peerReview: props.peerReview,
                                getDefaultHtml: function () {
                                    return props.initHtml;
                                },
                            },
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            ...props.extraInitConfig,
                        }}
                    />
                    </ToolBarAffix>
                </div>);
    }

    const insertTools = ['image'];
    if (!props.noMedia) {
        insertTools.push('media');
    }
    if (!props.noAttachment) {
        insertTools.push('attachment');
    }

    const isMobile = Helper.isMobile();
    const toolbar = isMobile ? [
        {
            name: 'insert',
            items: [...insertTools, 'alignleft', 'aligncenter', 'alignright', 'fullscreen'],
        }
    ] : [
        {
            name: 'insert',
            items: insertTools,
        },
        {
            name: 'basicstyles',
            items: ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'removeformat']
        },
        { name: 'colors', items: ['forecolor', 'backcolor'] },
        {
            name: 'paragraph',
            items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify', 'ltr', 'rtl']
        },
        {
            name: 'paragraph',
            items: ['numlist', 'bullist', 'outdent', 'indent', 'blockquote']
        },
        {
            name: 'insert',
            items: ['table', 'hr', 'emoticons', 'pagebreak']
        },
        {
            name: 'basicstyles',
            items: ['blocks']
        },
        /* { name: 'comment', items: ['sentencecomment', 'paragraphcomment'] }, */
        { name: 'styles', items: ['Format', 'fontfamily', 'fontsize'] }, //missing styles
        { name: 'links', items: ['link', 'unlink'] },
        { name: 'document', items: ['code', 'preview', 'print'] },
        {
            name: 'clipboard',
            items: ['cut', 'copy', 'paste', 'pastetext', 'undo', 'redo']
        },
        {
            name: 'editing',
            items: ['searchreplace', 'selectall']
        },
        { name: 'tools', items: ['fullscreen', 'visualblocks', 'About'] }
    ];
    return (
        <div className="form-group">
            <Editor
                ref={htmlEditorRef}
                tinymceScriptSrc={'/tinymce/tinymce.min.js'}
                //apiKey="60tqj5cv5mqacjd1yo0bfmtvktqx0gb1u51en8xzp91b673p"
                value={Helper.replaceHtmlVirtualPath(props.htmlContent)}
                onScriptsLoad={updateTinymce}
                onEditorChange={(newValue, editor) => {
                    if (!Helper.isMobile()) {
                        updateCommentSentencePopoversLater();
                    }

                    if (props.handleChangeEdit){
                        props.handleChangeEdit(newValue, props.index !== null && props.index !== undefined ? props.index : null);
                    }
                            if (props.handleChangeEditWithEditor){
                                props.handleChangeEditWithEditor(newValue, editor);
                            }
                }}
                init={{
                    init_instance_callback: (editor) => {
                        if (!Helper.isMobile()) {
                            updateCommentSentencePopoversLater();
                        }
                        editor.on('FullscreenStateChanged', onFullScreen.bind(editor));
                    },
                    height: props.height ? props.height : 400,
                    menubar: false,
                    branding: false,
                    convert_urls: false,
                    language: getTinymceLanguage(),
                    placeholder: props.placeholder || '',
                    disable_media: props.peerReview ? true : false,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'imagetools', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
                        'comment', 'placeholder', 'attachment',
                    ],
                    attachment_max_size: 104857600,
                    attachment_style:'.attachment>img{display:inline-block!important;max-width:30px!important;}',
                    attachment_icons_path: '/tinymce/plugins/attachment/icons',
                    attachment_upload_handler: attachment_upload_handler,
                    content_css: ['/tinymce/plugins/trackchanges/trackchange.css'],
                    images_upload_handler: image_upload_handler,
                    // NOTE: file_picker_callback无法显示上传状态
                    //file_picker_types: 'media',
                    //file_picker_callback: file_picker_callback,
                    toolbar_mode: 'sliding',
                    toolbar: toolbar,
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    ...props.extraInitConfig,
                }}
            />
        </div>
    );
};

const ExportHtml = (html) => {
    const iconPath = "data:image/svg+xml;base64,PHN2ZyBpZD0i57uEXzExNjMiIGRhdGEtbmFtZT0i57uEIDExNjMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjI1LjI3NCIgaGVpZ2h0PSIyNS4yNzQiIHZpZXdCb3g9IjAgMCAyNS4yNzQgMjUuMjc0Ij4KICA8cGF0aCBpZD0i6Lev5b6EXzI5OCIgZGF0YS1uYW1lPSLot6/lvoQgMjk4IiBkPSJNMTIuNjM3LDIzLjFBMTAuNDY1LDEwLjQ2NSwwLDEsMCwyLjE3MiwxMi42MzcsMTAuNDY1LDEwLjQ2NSwwLDAsMCwxMi42MzcsMjMuMVptMCwyLjE3MkExMi42MzcsMTIuNjM3LDAsMSwxLDI1LjI3NCwxMi42MzcsMTIuNjM3LDEyLjYzNywwLDAsMSwxMi42MzcsMjUuMjc0WiIgZmlsbD0iI2Y3NTQ1NCIvPgogIDxwYXRoIGlkPSLot6/lvoRfMjk5IiBkYXRhLW5hbWU9Iui3r+W+hCAyOTkiIGQ9Ik00NTAuNjY2LDIxMy4wODZhMS4wODYsMS4wODYsMCwxLDAtMi4xNzIsMHY4LjM3OWExLjA4NiwxLjA4NiwwLDEsMCwyLjE3MiwwWk00NDkuNTgsMjIzLjY1YTEuNTgsMS41OCwwLDEsMCwxLjU4LDEuNThBMS41OCwxLjU4LDAsMCwwLDQ0OS41OCwyMjMuNjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDM2Ljk0MiAtMjA2Ljc2NykiIGZpbGw9IiNmNzU0NTQiLz4KPC9zdmc+Cg==";
    let newHtml = html.replace(/\/tinymce\/icons\/info.svg/g, iconPath);
    newHtml = newHtml.replace(/\/tinymce\/icons\/info40.png/g, iconPath);
    newHtml = Helper.replaceHtmlVirtualPath(newHtml);

    let node = document.createElement("div");
    document.body.append(node);
    node.innerHTML = newHtml;
    let popovers = node.querySelectorAll(".aic-comment-sentence-popover");
    for (let i = 0; i < popovers.length; ++i) {
        let p = popovers[i];
        p.className = 'aic-comment-sentence-popover0';
        p.innerHTML = "<div class='aic-comment-sentence-popover'>" + p.innerText + "</div>";
    }
    newHtml = node.innerHTML;
    document.body.removeChild(node);

    //word 只能识别单独的 text-decoration: underline, 设置了color或者style都不认识
    // 单独处理一下
    const copyScript = `
        function copyOverride() {
            document.body.addEventListener("copy", (event) => {
              var html = rangy.getSelection().toHtml()
              
              var divContainer = document.createElement("div");
              divContainer.innerHTML = html;
              divContainer.querySelectorAll('.aic-comment-sentence-inner').forEach(item => {
                item.removeAttribute("style");
                item.setAttribute("style", "text-decoration:underline;");
              });
              event.clipboardData.setData("text/html", divContainer.innerHTML);
              console.log(divContainer.innerHTML)
              divContainer.remove();
              event.preventDefault();
            });
        }
        
        window.onload = function get_body() {
            copyOverride();
        }
    `;

    const finalHtml = `<!DOCTYPE html><html lang="zh"><head><meta charset="utf-8" /><style>${cssContent}   body { padding-top: 20px} </style><script>${rangyRaw}</script> <script>${copyScript}</script> </head><body class="aic-enable-highlight-diff">${newHtml}</body></html>`;
    return juice(finalHtml);
};

const fileServerPath = () => {
    if (AppConfig.FILE_SERVER) {
        if (AppConfig.FILE_SERVER.endsWith("/")) {
            return AppConfig.FILE_SERVER;
        }
        return AppConfig.FILE_SERVER + "/";
    }
    else return AppConfig.APP_SERVICE_BASE + "/";
};

const ReplaceUrlWithVirtualPath = (html) => {
    if (!html) {
        return html;
    }

    let result = html.split(fileServerPath()).join(file_server_place_holder + '~/');
    g_url_maps.forEach((value, key) => {
        result = result.split(key).join(value);
    });
    return result;
};

function formatHtmlNode(node) {
    let name = node.tagName.toLowerCase();
    if (name == 'p' || name == 'div') {
        const prefix = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        let html = node.innerHTML.trim();
        if (html) {
            while (html.startsWith("&nbsp;")) {
                html = html.substring(6).trim();
            }

            let text = node.innerText.trim();
            if (html[0] === text[0]) {
                if (html) {
                    node.innerHTML = prefix + html;
                }
            }
        }
    }

    if (node.children) {
        for (let i = 0; i < node.children.length; ++i) {
            let child = node.children[i];
            formatHtmlNode(child);
        }
    }
}

function FormatHtmlAnswer(html) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, "text/html");
    let body = doc.body;
    if (body.children) {
        const prefix = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
        for (let i = 0; i < body.children.length; ++i) {
            let node = body.children[i];
            formatHtmlNode(node);
        }
    }

    let s = new XMLSerializer();
    let result = s.serializeToString(body);
    if (result.startsWith("<body")) {
        let i = result.indexOf(">");
        if (i >= 0) {
            result = result.substring(i + 1);
            let j = result.lastIndexOf("</body>");
            if (j >= 0) {
                result = result.substring(0, j);
            }
        }
    }
    return result;
}

var g_fullscreen = false;
var g_events = new EventEmitter();

function IsFullScreen() {
    return g_fullscreen;
}

function AddFullScreenListener(cb) {
    g_events.on('fullscreen', cb);
}

function RemoveFullScreenListener(cb) {
    g_events.off('fullscreen', cb);
}

function onFullScreen(e) {
    if (e.state) {
        g_fullscreen = true;
    } else {
        g_fullscreen = false;
    }

    g_events.emit('fullscreen', g_fullscreen);
    if (document.activeElement) {
        document.activeElement.blur();
        //this.execCommand('mceBlur');
    }

    /*
    let editor = this;
    setTimeout(() => {
        let p = editor.getContainer();
        p.scrollTop = 0;
        p.scrollTo(0, 0);
        p = editor.getBody();
        p.scrollTop = 0;
        p.scrollTo(0, 0);
        p = editor.iframeElement;
        p.scrollTop = 0;
        p.contentWindow.scrollTo(0, 0);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        alert('ok');
    }, 5000);
    */
}

export default withTranslation(uid)(HTMLEditor);
export { ExportHtml, ReplaceUrlWithVirtualPath, FormatHtmlAnswer, updateCommentSentencePopoversLater,
         IsFullScreen, AddFullScreenListener, RemoveFullScreenListener };
